import styled from 'styled-components';
import {ListTitleDefaultBox} from './list-title.default.box';

export const ListTitleCasino777Box = styled(ListTitleDefaultBox)`
    &:before {
        content: none
    }
`;
